<template>
  <div>
    <AppMenu />
    <BaseBreadcrumb
      :title="$t(title)"
      :help="help"
      :breadcrumbs="breadcrumbs"
      :tutorial="tutorial"
      module="cash-register-turn"
    >
      <template v-slot:actions>
        <v-btn small outlined color="primary" class="mr-2" title="Volver a consultar" @click="search(form, 1)">
          <v-icon small left>mdi-restart</v-icon>Actualizar
        </v-btn>
        <v-btn
          v-if="$store.getters.turn"
          id="btn-turnos-cerrar-turno"
          small
          depressed
          color="primary"
          to="/pos/close-turn"
          title="Contar la caja y cerrar el turno abierto"
        >
          <v-icon small left>mdi-store-minus-outline</v-icon>Cerrar turno
        </v-btn>
      </template>
    </BaseBreadcrumb>

    <PanelFiltros
      :form="form"
      :cargando="loading"
      :labels="{ opened: 'Estado', opening_date: 'Fecha de apertura' }"
      @filtrar="search(form, 1)"
    >
      <v-select
        v-model="form.opened"
        :items="[{ text: 'Abierto', value: 'true' }, { text: 'Cerrado', value: 'false' }]"
        label="Estado del turno"
        outlined
        dense
        clearable
        hide-details
        class="mb-3"
      ></v-select>
      <ng-date-range v-model="form.opening_date" label="Fecha de apertura"></ng-date-range>
    </PanelFiltros>

    <v-card class="mt-3 mx-3">
      <SkeletonLista v-if="loading && (!items || !items.length)" :columnas="7" />
      <div v-else class="px-2">
        <v-data-table
          mobile-breakpoint="700"
          :options.sync="options"
          :disable-filtering="true"
          :disable-sort="true"
          v-on:update:page="changePage"
          v-on:update:sort-by="changeOrder"
          v-on:update:sort-desc="changeOrder"
          v-on:update:items-per-page="changeItemsPerPage"
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :hide-default-footer="hidePaginator()"
          :loading="loading"
          class="listing-app"
          item-key="id"
          :show-expand="false"
          :expanded.sync="expanded"
          :footer-props="{
            'items-per-page-options': options.itemsPerPageOptions,
            'items-per-page-text': $t('records_per_page'),
          }"
        >
          <template v-slot:item._actions="{ item }">
            <div class="d-flex flex-wrap justify-end py-1">
              <v-btn small outlined color="primary" class="mr-1" :title="'Imprimir el cuadre del turno'" @click="executePrintTurn(item)">
                <v-icon small left>mdi-cash-register</v-icon>Cuadre
              </v-btn>
              <v-btn small outlined color="primary" :title="'Imprimir el reporte fiscal'" @click="executePrintReportFiscalServer(item)">
                <v-icon small left>mdi-file-document-outline</v-icon>Reporte fiscal
              </v-btn>
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.cash_register
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-cash_register"
            >
              {{ $t("cash_register") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.opening_date
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-opening_date"
            >
              {{ $t("opening_date") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.closing_date
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-closing_date"
            >
              {{ $t("closing_date") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.starting_amount
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-starting_amount"
            >
              {{ $t("starting_amount") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.total_sales
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-total_sales"
            >
              {{ $t("total_sales") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.final_amount
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-final_amount"
            >
              {{ $t("final_amount") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.difference
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-difference"
            >
              {{ $t("difference") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.delivery_amount
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-delivery_amount"
            >
              {{ $t("delivery_amount") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.tip_amount
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-tip_amount"
            >
              {{ $t("tip_amount") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <!-- <template v-slot:header.is_sync
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-is_sync"
            >
              {{ $t("is_sync") }}
            </span>
          </template> -->
          <!-- eslint-disable-next-line -->
          <template v-slot:header.opened
            ><span
              class="body-2 font-weight-bold"
              id="header-item-cash-register-turn-opened"
            >
              {{ $t("opened") }}
            </span>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.cash_register="{ item }">
            <div
              class="field-cash-register-turn-cash_register"
              :class="'cash-register-turn-cash_register-' + item.id"
            >
              {{ $filters.name(item.cash_register) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.opening_date="{ item }">
            <div
              class="field-cash-register-turn-opening_date"
              :class="'cash-register-turn-opening_date-' + item.id"
            >
              {{ $filters.date(item.opening_date) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.closing_date="{ item }">
            <div
              class="field-cash-register-turn-closing_date"
              :class="'cash-register-turn-closing_date-' + item.id"
            >
              {{ $filters.date(item.closing_date) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.starting_amount="{ item }">
            <div
              class="field-cash-register-turn-starting_amount"
              :class="'cash-register-turn-starting_amount-' + item.id"
            >
              {{ $filters.currency(item.starting_amount) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.total_sales="{ item }">
            <div
              class="field-cash-register-turn-total_sales"
              :class="'cash-register-turn-total_sales-' + item.id"
            >
              {{ $filters.currency(item.total_sales) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.final_amount="{ item }">
            <div
              class="field-cash-register-turn-final_amount"
              :class="'cash-register-turn-final_amount-' + item.id"
            >
              {{ $filters.currency(item.final_amount) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.difference="{ item }">
            <div
              class="field-cash-register-turn-difference"
              :class="'cash-register-turn-difference-' + item.id"
            >
              {{ $filters.currency(item.difference) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.delivery_amount="{ item }">
            <div
              class="field-cash-register-turn-delivery_amount"
              :class="'cash-register-turn-delivery_amount-' + item.id"
            >
              {{ $filters.currency(item.delivery_amount) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.tip_amount="{ item }">
            <div
              class="field-cash-register-turn-tip_amount"
              :class="'cash-register-turn-tip_amount-' + item.id"
            >
              {{ $filters.currency(item.tip_amount) }}
            </div>
          </template>
          <!-- eslint-disable-next-line -->
          <!-- <template v-slot:item.is_sync="{ item }">
            <div
              class="field-cash-register-turn-is_sync"
              :class="'cash-register-turn-is_sync-' + item.id"
            >
              <span class="field-string">
                <v-chip small dark color="primary" v-if="item.is_sync">
                  {{ $t("synchronized") }}
                </v-chip>
                <v-chip small dark color="red" v-else>
                  {{ $t("no_synchronized") }}
                </v-chip>
              </span>
            </div>
          </template> -->
          <!-- eslint-disable-next-line -->
          <template v-slot:item.opened="{ item }">
            <div
              class="field-cash-register-turn-opened"
              :class="'cash-register-turn-opened-' + item.id"
            >
              <span class="field-string">
                <v-chip small dark color="success" v-if="item.opened">
                  {{ $t("opened") }}
                </v-chip>
                <v-chip small dark color="red" v-else>
                  {{ $t("closed") }}
                </v-chip>
              </span>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import AppMenu from "../menu/AppMenu.vue";
import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
import printManager from "@/plugins/print-manager";

/*
import * as templateDesktop from "./CashRegisterTurnListDesktop.vue?vue&type=template";
import * as templateMobile from "./CashRegisterTurnListMobile.vue?vue&type=template";
let render = templateDesktop.render;
if (window.innerWidth < 960) {
  render = templateMobile.render;
}*/

export default {
  mixins: [NextMixinListPage, MixinActions],
  components: { AppMenu },
  //render: render,
  data() {
    return {
      title: "Turnos",
      form: {},
      url: "api/v1/cash-turn",
      pathBase: "/bill/cash-turn",
      pathCreate: "/bill/cash-turn/create",
      options: {
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        sortBy: ["opening_date"],
        sortDesc: [true],
      },

      headers: [
                { text: "Caja", title: "cash_register", value: "cash_register", sortable: false },
        { text: "Fecha apertura", title: "opening_date", value: "opening_date", sortable: true },
        { text: "Fecha cierre", title: "closing_date", value: "closing_date", sortable: true },
        { text: "Monto inicial", title: "starting_amount", value: "starting_amount", sortable: true },
        { text: "Total ventas", title: "total_sales", value: "total_sales", sortable: true },
        { text: "Monto registrado", title: "final_amount", value: "final_amount", sortable: true },
        { text: "Diferencia", title: "difference", value: "difference", sortable: true },
        { text: "Total domicilios", title: "delivery_amount", value: "delivery_amount", sortable: true },
        { text: "Total propinas", title: "tip_amount", value: "tip_amount", sortable: true },
        { text: "Estado", title: "opened", value: "opened", sortable: true },
        { text: "Acciones", title: "_actions", value: "_actions", sortable: false },
      ],
    };
  },
  methods: {
    breadcrumbsInit() {
      this.breadcrumbs = [
        {
          text: this.$t("Inicio"),
          disabled: false,
          to: "/pos",
          "exact-path": true,
        },
        {
          text: this.$t("Turnos"),
          disabled: false,
          "exact-path": true,
        },
        {
          text: this.$t("cash-register-turn-list"),
          disabled: true,
          to: "",
          "exact-path": true,
        },
      ];
    },

    search(params, page) {
      //console.log(this.$store.getters.installation, '----------')
      if (!this.$store.getters.installation) {
        setTimeout(() => {
          this.search(params, page);
        }, 1500);
        return;
      }
      let cashRegister = { id: this.$store.getters.installation.cash_id };
      const { data, paginate, order } = this.getParamsForQuery(params, page);
      this._paginaPedida = paginate.page;
      if (this.options.page !== paginate.page) {
        this.options.page = paginate.page;
      }
      const numero = (this._numeroBusqueda = (this._numeroBusqueda || 0) + 1);
      this.loading = true;
      this.querySelections(
        { ...data, cash_register: cashRegister },
        paginate,
        order
      ).then((data) => {
        if (numero !== this._numeroBusqueda) {
          return;
        }
        this.items = data.items;
        this.total = data.total;
        this.moduleActions = data.module_actions;
        this.itemsKey++;
      }).catch(() => {
        this.loading = false;
      });
    },
    toogleDrawer() {
      this.$store.commit("toggle");
    },
    openHelp() {
      window.open(process.env.VUE_APP_BASECONFIG_URL_HELP, "_blank");
    },

    async executePrintTurn(item) {
      // this.$pos.printTurn(item);
      const res = await this.$http.get(
        "api/v1/cash-turn-pos/" + item.id,
        null,
        true
      );
      if (res.success) {
        printManager.printFromFormat(res.data,this.$store,null,this.$db, res.type);                       
      }
    },

    async executePrintReportFiscal(item) {
      this.$pos.printTurnReportFiscal(item);
    },
    async executePrintReportFiscalServer(item) {
      this.$http
        .get("api/v1/cash-turn-tax-report/" + item.id, {}, true, false)
        .then((response) => {
          if (response.success) {
            if (response.data) {
              this.$pos.printTurnReportFiscalServer(response.data);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>
